(function () {
    'use strict';

    angular
        .module('app.campaignAdvertiserManagePage', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.campaignAdvertiserManagePage', {
                    requireLogin: true,
                    url: 'campaign/advertiser',
                    templateUrl: 'app/campaign/campaignAdvertiserManagePage/campaignAdvertiserManagePage.html?app_v=deployDate',
                    controller: 'campaignAdvertiserManagePageCtrl',
                    scope: {},
                    data: {
                        authorizedRoles: ['Administrator', 'User'],
                        navMarker: ['campaign']
                    }
                });
        }]);
})();